export default Object.freeze({
  L1: 1,
  L2: 2,
  L3: 3,
  L4: 4,
  NT: 5,
  L0: 6,
  L5: 7
});
